export default __webpack_public_path__ + "static/media/twitter.14c45954.svg";